import { render, staticRenderFns } from "./VerificationCaseStudyScreen.vue?vue&type=template&id=824bc87e"
import script from "./VerificationCaseStudyScreen.vue?vue&type=script&lang=js"
export * from "./VerificationCaseStudyScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports